module.exports = __webpack_public_path__ + "img/b.f3bce2fe.svg";